export interface CreatorRef {
  platform: string;
  platformId: string;
}

export const creatorKey = ({ platform, platformId }: CreatorRef) => `${platform}:${platformId}`;

export const bareHandle = (handle: string) => handle.replace(/^@/, '');

export const handleKey = (handle: string) => bareHandle(handle).toLowerCase();
